import { Moment } from 'jalali-moment';
import Flex from '../Flex';
import IcArrow from '../IcArrow';

import './styles.css';

export interface DateSelectorBarProps {
  dates: Moment[];
  selected: number;
  startDate: Moment;
  variant: ComponentVariant;
  onPrevWeekClick: () => any;
  onNextWeekClick: () => any;
  onDayClick: (index: number) => any;
}

export function DateSelectorBar({
  selected,
  startDate,
  onPrevWeekClick,
  onNextWeekClick,
  onDayClick,
  dates,
  variant = 'nurture',
}: DateSelectorBarProps) {
  return (
    <Flex className="date-selector-bar !py-4" gap={0}>
      <Flex
        inlineFlex
        align="center"
        justify="center"
        className="mb-1"
        onClick={onPrevWeekClick}
      >
        <IcArrow size={8} type="up" />
      </Flex>
      <Flex className="date-text">{startDate.format('jYYYY/jMM/jDD')}</Flex>
      <Flex direction="column">
        {dates.map((day, i) => {
          const classes = i === selected ?
            `!bg-${variant}-extra-light border-${variant} text-${variant}` :
            'border-transparent text-[#555]';
          return (
            <div
              key={i}
              onClick={() => onDayClick(i)}
              className={'week-day-item ' + classes}>{day.locale('fa').format('dddd')}
            </div>
          );
        })}
      </Flex>
      <Flex className="date-text">
        {startDate.clone().add(7, 'jDay').format('jYYYY/jMM/jDD')}
      </Flex>
      <Flex
        className="mt-1"
        align="center"
        justify="center"
        onClick={onNextWeekClick}
      ><IcArrow size={8} type="down" /></Flex>
    </Flex>
  );
}

export default DateSelectorBar;
